export default __webpack_public_path__ + "static/media/AVENIRNEXTLTPRO-REGULAR_0.94f2f163.OTF";